import React from 'react'

function DataTableHead() {
    return (
        <thead className='DataTableHead'>
        <tr>
            <th rowSpan={2}>SKU</th>
            <th rowSpan={2} className='text-center'>Số lượng</th>
            <th colSpan={9} className='text-center'>Các trạng thái</th>
        </tr>
        <tr>
            <th className='text-center'>Pending</th>
            {/* <th className='text-center'>Đang in</th> */}
            <th className='text-center'>Đã in</th>
            <th className='text-center'>Đã cắt</th>
            <th className='text-center'>Đã khắc</th>
            <th className='text-center'>Đã hoàn thiện</th>
            {/* <th className='text-center'>Chờ may</th>
            <th className='text-center'>Đang may</th> */}
            <th className='text-center'>Hoàn thành</th>
        </tr>
        </thead>
    )
}

export default DataTableHead
